/* eslint-disable no-underscore-dangle */
import { DomConverter, Plugin, Widget } from 'ckeditor5'

function isBlockViewElement(
  node: any,
  blockElements: DomConverter['blockElements'],
): boolean {
  return (
    Boolean(node) && node.is('element') && blockElements.includes(node.name)
  )
}

// By default CKEditor tries to wrap every <br/> in a paragraph which is actually correct in a HTML semantic perspective.
// But we need to override this behavior to avoid duplicated lines. This is because many of our data was saved using <br/>
// without using another wrapper tag.
// Example:
// Input (old editor): '<p>some text<br/></p>'
// CKeditor default behavior: '<p>some text</p><p><br>&nbsp;</p>' - leads to duplicated line
// CKEditor new behavior:
//  - Data and editing downcast (what is actually see and saved): '<p>some text</p><p>&nbsp;</p>'
export default class CustomSoftBreak extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this._defineConverters()
  }

  _defineConverters() {
    const { conversion } = this.editor

    conversion.for('upcast').elementToElement({
      model: (element, { writer: modelWriter }) => {
        let softBreak = modelWriter.createElement('softBreak')

        const { nextSibling, previousSibling } = element
        const { blockElements } = new DomConverter(element.document, {
          renderingMode: 'data',
        })

        const previousSiblingIsBlock = isBlockViewElement(
          previousSibling,
          blockElements,
        )
        const nextSiblingIsBlock = isBlockViewElement(
          nextSibling,
          blockElements,
        )

        if (
          element.name === 'br'
          && (previousSiblingIsBlock || nextSiblingIsBlock)
          && !element.hasClass('Apple-interchange-newline')
        ) {
          softBreak = modelWriter.createElement('paragraph')
        }

        return softBreak
      },
      view: 'br',
      converterPriority: 'high',
    })
  }
}
